import { QueryCache, QueryClient } from "@tanstack/react-query";
import { Logger } from "../logger";

const getQueryClient = (): QueryClient =>
  new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        Logger.error("Query Error", error as Error);
      },
    }),
  });

export default getQueryClient;
